import { PickupPlacement } from "./PickupPlacement";
import { INVENTORY, PLACEMENT_TYPE_HERO } from "../helpers/consts";
import { TILES } from "../helpers/tiles";
import Sprite from "../components/object-graphics/Sprite";

export class BulletPickupPlacement extends PickupPlacement {
  addsItemToInventoryOnCollide(body) {
    if (body.type === PLACEMENT_TYPE_HERO) {
      return INVENTORY.BULLET_PICKUP;
    }
    return null;
  }

  renderComponent() {
    return <Sprite frameCoord={TILES.BULLET_PICKUP} />;
  }
}
